import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface Payload {
  listingId: number;
  startDate?: string;
  endDate?: string;
}

export default (makeCall: MakeCall) => (data: Payload) => {
  return makeCall<undefined>('POST', `/api/v2/conversations/prospective-lead`, {
    data,
  });
};
